// extracted by mini-css-extract-plugin
module.exports = {"accessoryGrid":"idt-accessorygrid_accessorygrid__2-3uj"};